import { IConexaResponse } from '@/@types/generic-types'
import httpClient from '@/services/httpClient'
import {
  BiometryStartResponse,
  GetBiometryResultWithClinicParams,
  GetBiometryResultWithClinicResponse,
  StartBiometryWithClinicParams,
} from './types'

const normalizeCpf = (cpf: string) => {
  return cpf.replace(/\D/g, '')
}

export class BiometryService {
  static async biometryStart(callbackUri: string) {
    const { data } = await httpClient.post<
      IConexaResponse<BiometryStartResponse>
    >('/biometry/start', {
      callbackUri,
    })
    return data?.object
  }

  static async biometryStartPatient(
    callbackUri: string,
    cpf: string,
    captcha: string,
  ) {
    const normalizedCpf = normalizeCpf(cpf)

    const { data } = await httpClient.post<
      IConexaResponse<BiometryStartResponse>
    >(
      `/biometry/patient/cpf/${normalizedCpf}/start`,
      {
        callbackUri,
      },
      {
        headers: {
          captcha,
        },
      },
    )
    return data?.object
  }

  static async getBiometryResult(
    cpf: string,
    proccessId: string,
    captcha: string,
  ) {
    const normalizedCpf = normalizeCpf(cpf)

    const { data } = await httpClient.get<
      IConexaResponse<GetBiometryResultWithClinicResponse>
    >(`/biometry/patient/cpf/${normalizedCpf}/result/${proccessId}`, {
      headers: {
        captcha,
      },
    })
    return data?.object
  }

  static async biometryStartWithClinic({
    callbackUri,
    cpf,
    captcha,
    clinicId,
    action,
  }: StartBiometryWithClinicParams) {
    const normalizedCpf = normalizeCpf(cpf)

    const { data } = await httpClient.post<
      IConexaResponse<BiometryStartResponse>
    >(
      `/biometry/patient/signup/start`,
      {
        callbackUri,
        cpf: normalizedCpf,
        clinicId,
        action,
      },
      {
        headers: {
          captcha,
        },
      },
    )

    return data?.object
  }

  static async getBiometryResultWithClinic({
    cpf,
    captcha,
    clinicId,
    processId,
  }: GetBiometryResultWithClinicParams) {
    const normalizedCpf = normalizeCpf(cpf)

    const { data } = await httpClient.get<
      IConexaResponse<GetBiometryResultWithClinicResponse>
    >(
      `/biometry/patient/signup/${clinicId}/${normalizedCpf}/result/${processId}`,
      {
        headers: {
          captcha,
        },
      },
    )

    return data?.object
  }
}
